var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutSectionStepIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{display:none}.st1,.st3{display:inline}.st3,.st5{fill:#fff}")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.062,
    y1: 541.47,
    x2: 1067,
    y2: 541.47
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#404040"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404040"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 541.53,
    cy: 541.47,
    r: 525.47,
    style: {
      fill: "url(#SVGID_5_)"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M658.51 267H395.9c-18.09 0-32.75 13.47-32.75 30.08v498.26c0 16.62 14.67 30.08 32.75 30.08h262.61c18.09 0 32.76-13.46 32.76-30.08V297.08c0-16.61-14.67-30.08-32.76-30.08zM409.2 284.14c6.15 0 11.15 4.99 11.15 11.15s-5 11.15-11.15 11.15c-6.16 0-11.14-4.99-11.14-11.15s4.99-11.15 11.14-11.15zM671.48 768.2H382.94V324.21h288.54V768.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M574.81 608.83c-38.02 0-68.95 30.93-68.95 68.95s30.93 68.95 68.95 68.95 68.95-30.93 68.95-68.95-30.93-68.95-68.95-68.95zm0 123.6c-30.18 0-54.65-24.46-54.65-54.65 0-30.18 24.46-54.65 54.65-54.65 30.18 0 54.65 24.46 54.65 54.65 0 30.18-24.47 54.65-54.65 54.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m554.52 666.65-18.7-.03 34.47 54.12 47.42-64.46h-20.87l-27.12 36.03zM619.05 495.16c0 13.09-10.69 23.78-23.79 23.78H397.94v-47.56h197.32c13.1 0 23.79 10.69 23.79 23.78zM397.94 654.04h119.04v47.56H397.94zM526.19 586.49c0 13.09-10.68 23.78-23.78 23.78H397.94v-47.56h104.47c13.1 0 23.78 10.69 23.78 23.78zM580.83 403.83c0 13.09-10.69 23.78-23.77 23.78H397.94v-47.56h159.12c13.09 0 23.77 10.68 23.77 23.78z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutSectionStepIcon3);
export default __webpack_public_path__ + "static/media/about_section_step_icon_3.378fbfebb748f6cc8088edef2438d5b3.svg";
export { ForwardRef as ReactComponent };